import { composeMiddleware } from './module';
import { analyticsActions } from './state';
import { IActionTransformFilter } from './types';

export const trackingMiddleware = (p: { trackableActions: string[]; actionHandlers?: IActionTransformFilter[] }) => {
  const { trackableActions, actionHandlers } = p;
  return composeMiddleware(() => next => action => {
    const matchedHandler = !!actionHandlers && actionHandlers.find(handler => handler.predicate(action));

    if (
      action.type === analyticsActions.clear.actionType ||
      action.type === analyticsActions.track.actionType ||
      (trackableActions.indexOf(action.type) === -1 && !matchedHandler)
    ) {
      return next(action);
    }

    if (trackableActions.indexOf(action.type) > -1) {
      setTimeout(() => next(analyticsActions.track.create(action)), 1);
      return next(action);
    }

    if (matchedHandler) {
      setTimeout(() => next(analyticsActions.track.create(matchedHandler.transform(action))), 1);
      return next(action);
    }

    return next(action);
  });
};
